import { useEffect, useState } from "react"
import axios from "axios"
import URL from "../config/API"




function Contact() {
    const [contact, setcontact] = useState();
    const [contactId, setcontactId] = useState();


    const [contactfrom, setcontactForm] = useState({
        mobile: "",
        userId: 1
    })
    const submitContact = (e) => {
        e.preventDefault()
        axios.post(`${URL.BASE_URL}/save-contact`, contactfrom, {
            headers: {
                "Content-Type": "application/json"
            }
        }).then(res => {
            console.log(res);

        })

    }
    const eventHendler = (e) => {
        setcontactForm(preState => ({ ...preState, [e.target.name]: e.target.value }))
    }


    return (

        <>
            <div className="modal fade" id="contact-add">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <button className="modal-close" data-bs-dismiss="modal"><i className="icofont-close"></i></button>
                        <form className="modal-form">
                            <div className="form-title">
                                <h3>add new contact</h3>
                            </div>
                            <div className="form-group">
                                <label className="form-label">title</label>
                                <select className="form-select">
                                    <option selected>choose title</option>
                                    <option value="primary">primary</option>
                                    <option value="secondary">secondary</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="form-label">number</label>
                                <input className="form-control" type="text" placeholder="Enter your number" />
                            </div>
                            <button className="form-btn" type="submit">save contact info</button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    )

}

export default Contact;